module.exports = __webpack_public_path__ + "static/MonumentExtended-Regular-243f566d3815ac82cd19e0ed6ce6fdeb.woff2";